import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useState } from 'react'
import Icon from 'components/shared/Icon'

interface MobileOpeningHoursBoxProps {
    rows: string[]
    title: string
    hours: string[]
}

const MobileOpeningHoursBox = ({
    rows,
    title,
    hours,
}: MobileOpeningHoursBoxProps) => {
    const [isBoxOpen, setIsBoxOpen] = useState(false)

    const handleBoxToggle = () => {
        setIsBoxOpen(!isBoxOpen)
    }
    return (
        <Box key={title} isFullWidth>
            <Box
                direction="row"
                isFullWidth
                justify="space-between"
                mb={isBoxOpen ? 12 : 0}
                onClick={handleBoxToggle}
            >
                <Text variant="body" color="grayscale_900">
                    {title}
                </Text>
                <Icon
                    variant="chevron"
                    color="wellness"
                    rotation={isBoxOpen ? 180 : 0}
                />
            </Box>
            {isBoxOpen && (
                <ul>
                    {rows?.map((row, index) => (
                        <li key={row}>
                            <Box direction="row" justify="space-between">
                                <Text variant="bodySmall" color="grayscale_900">
                                    {row}
                                </Text>
                                <Text variant="bodySmall" color="wellness">
                                    {hours[index]}
                                </Text>
                            </Box>
                        </li>
                    ))}
                </ul>
            )}
        </Box>
    )
}

export default MobileOpeningHoursBox
